import { LogService } from 'services';

/* eslint-disable prefer-const */
export const cpfMask = (value: string | undefined, hiddenInfo?: boolean) => {
  if (!value) return '';
  if (hiddenInfo) {
    const cleanCPF = value.replace(/\D/g, '');

    return `${cleanCPF?.slice(0, 3)}.xxx.xxx-${cleanCPF?.slice(-2)}`;
  }

  return value
    .replace(/\D+/g, '')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d{1,2})$/, '$1-$2');
};

export const drtMask = (value: string | undefined) => {
  if (!value) return '';
  return value
    .replace(/\D+/g, '')
    .replace(/(\d{5})(\d)/, '$1.$2')
    .replace(/(\d{6})(\d)/, '$1/$2')
    .replace(/(\d{4})(\d{1,2})$/, '$1-$2');
};

export const dateMask = (value: string | undefined) => {
  if (!value) return '';
  return value
    .replace(/\D+/g, '')
    .replace(/(\d{2})(\d)/, '$1/$2')
    .replace(/(\d{2})(\d)/, '$1/$2')
    .replace(/(\d{4})(\d)/, '$1');
};

export const renavamMask = (value: string) => {
  if (!value) return '';
  return value.replace(/\D+/g, '').replace(/(\d{10})(\d)/, '$1-$2');
};

export const phoneMask = (value?: string) => {
  if (!value) return '';
  value = value.replace(/\D/g, '');
  value = value.replace(/(\d{2})(\d)/, '($1) $2');
  value = value.replace(/(\d)(\d{4})$/, '$1-$2');
  return value;
};

export const formatCurrency = (value: number): string => {
  try {
    value = Number(value);

    const formatter = new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    return formatter.format(value);
  } catch (error: any) {
    LogService.error('formatCurrency() error: ', error);
    return '';
  }
};

/*
  feat: This function should can add or remove the mask when the value is
  a number of license, in specify 'permitNumber'.
  
  Example:

  - add:
    Input: 07009038020238070013
    Output: 0700903-80.2023.8.07.0013

  - remove:
    Input: 0700903-80.2023.8.07.0013
    Output: 07009038020238070013
*/
export const maskPermitNumber = {
  add: (value: string) => {
    value = value.replace(/\D/g, '');

    let maskedValue = value;

    if (value?.length > 7) maskedValue = value.replace(/^(\d{0,7})/, '$1-');
    if (value?.length > 9) maskedValue = maskedValue.replace(/^(\d{0,7}-\d{0,2})/, '$1.');
    if (value?.length > 13) maskedValue = maskedValue.replace(/^(\d{0,7}-\d{0,2}\.\d{0,4})/, '$1.');
    if (value?.length > 14) maskedValue = maskedValue.replace(/^(\d{0,7}-\d{0,2}\.\d{0,4}\.\d?)/, '$1.');
    if (value?.length > 16) maskedValue = maskedValue.replace(/^(\d{0,7}-\d{0,2}\.\d{0,4}\.\d?\.\d{0,2})/, '$1.');

    return maskedValue;
  },
  remove: (value: string) => {
    value = value?.replace('.', '')?.replace('.', '')?.replace('.', '')?.replace('.', '')?.replace('-', '');
    return value;
  },
};
